import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import RootStyle from "./root.style";
import theme from "./config/theme";
import { lightTheme } from "./config/themeConfig";
import { ThemeProvider } from 'styled-components';
import { ConfigProvider } from "antd";
import { BrowserRouter as Router } from "react-router-dom";
import Routers from "./routers";
const App = () => {
    return (_jsx(ThemeProvider, { theme: theme, children: _jsxs(ConfigProvider, { prefixCls: "bc", theme: lightTheme, children: [_jsx(RootStyle, {}), _jsx(Router, { children: _jsx(Routers, {}) })] }) }));
};
export default App;
